import API from './API';

// -----------------------------------------------------------------------------
//  Advisor (M4 / COD7).
//
//  L'advisor segue uno o più partner e matura una provvigione mensile su quello
//  che producono. È SOLO anagrafica (niente login) e una risorsa SIMBA: il
//  backend riserva `/advisor` ai ruoli globali.
//
//  ⚠️ L'associazione advisor ↔ partner è una M2M dichiarata sull'ADVISOR: i
//  partner seguiti si scrivono con `partners: [{ id }]` sul PATCH dell'advisor,
//  non dal partner.
// -----------------------------------------------------------------------------

function normalize(response) {
  const body = response?.data;
  if (Array.isArray(body)) return { rows: body, total: body.length };
  return { rows: body?.data ?? [], total: body?.total ?? 0 };
}

export default {
  getAdvisors({ search = '' } = {}) {
    const params = { join: ['partners'], sort: 'surname,ASC' };
    const t = search.trim();
    if (t) {
      params.s = JSON.stringify({
        $or: [
          { name: { $contL: t } },
          { surname: { $contL: t } },
          { mail: { $contL: t } },
        ],
      });
    }
    return API.get('/advisor', { params }).then((r) => normalize(r).rows);
  },

  createAdvisor(advisor) {
    return API.post('/advisor', advisor).then((r) => r.data);
  },

  updateAdvisor(id, patch) {
    return API.patch(`/advisor/${id}`, patch).then((r) => r.data);
  },

  // Non si cancella: le provvigioni dei mesi chiusi restano legate a lui.
  setAdvisorActive(id, active) {
    return API.patch(`/advisor/${id}`, { is_active: !!active }).then((r) => r.data);
  },

  // Solo id e ragione sociale, per la tendina dei partner seguiti.
  getPartnerOptions() {
    return API.get('/partner', {
      params: { fields: 'company_name', sort: 'company_name,ASC', limit: 1000 },
    }).then((r) => normalize(r).rows);
  },
};
